import NoResultsCard from './NoResultsCard'

export default NoResultsCard
